import { unpackToDateTime } from '@campfire/hot-date';
import { DateTime } from 'luxon';
import { FormFieldConfig, FormFieldValue, FormSubmissionFieldValue } from './form-responses-types';

export const parseUserAgent = (ua: string | null | undefined): { browser: string; os: string; device: string } => {
  if (!ua) return { browser: '-', os: '-', device: '-' };

  let browser = 'Unknown';
  let os = 'Unknown';
  let device = 'Desktop';

  if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';
  else if (ua.includes('Opera') || ua.includes('OPR/')) browser = 'Opera';

  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

  if (ua.includes('Mobile') || ua.includes('Android')) device = 'Mobile';
  else if (ua.includes('Tablet') || ua.includes('iPad')) device = 'Tablet';

  return { browser, os, device };
};

export const formatSubmissionDate = (dateStr: string): string => {
  const dt = unpackToDateTime(dateStr);
  const formattedDate = dt.toLocaleString(DateTime.DATE_MED);
  const formattedTime = dt.toFormat('h:mm a');
  return `${formattedDate}, ${formattedTime}`;
};

export const getFieldValue = (
  submission: { formFieldValues?: FormFieldValue[] },
  taskFieldId: string
): string => {
  const fieldValue = submission.formFieldValues?.find((fv) => fv.taskFieldId === taskFieldId);
  return fieldValue?.value || '-';
};

export const sortFieldValuesByFormOrder = (
  fieldValues: FormSubmissionFieldValue[],
  formFields: FormFieldConfig[]
): FormSubmissionFieldValue[] => {
  if (!fieldValues || !formFields.length) return fieldValues || [];
  const orderMap = new Map(formFields.map((f, idx) => [f.taskFieldId, idx]));
  return [...fieldValues].sort((a, b) => {
    const orderA = orderMap.get(a.taskFieldId) ?? 999;
    const orderB = orderMap.get(b.taskFieldId) ?? 999;
    return orderA - orderB;
  });
};

export const escapeCSV = (value: string): string => {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};
